import {Action} from '@ngrx/store';

export const MAIL_TO_ACTION = 'MAIL_TO_ACTION';

export class MailToActions implements Action {
  readonly type = MAIL_TO_ACTION;

  constructor(public payload: any) {
  }
}
